<template>
  <v-layout column>
    <v-data-table
      :headers="headers"
      :items="shippings"
      :loading="loading"
      no-data-text="Нет данных"
      hide-actions
      class="elevation-0"
      data-test="table"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item.shippingNumber }}
        </td>
        <td class="text-xs-left">
          {{ props.item.routeNumber }}
        </td>
        <td class="text-xs-left">
          {{ props.item.client.title }}
        </td>
        <td class="text-xs-left">
          {{ props.item.sender ? props.item.sender.title : "" }}
        </td>
        <td class="text-xs-left">
          <v-edit-dialog
            :return-value.sync="props.item.number"
            lazy
            large
            cancel-text="Отмена"
            save-text="Ок"
            @save="updateItem(props.item)"
          >
            <div>{{ props.item.number }}</div>
            <template v-slot:input>
              <v-text-field
                v-model="props.item.number"
                label="Номер проформы"
                hide-details
                data-test="number"
              />
            </template>
          </v-edit-dialog>
        </td>
        <td
          v-if="props.item.isPartialPlan"
          class="text-xs-left"
        >
          <v-edit-dialog
            :return-value.sync="props.item.volume"
            lazy
            large
            cancel-text="Отмена"
            save-text="Ок"
            @save="updateItem(props.item)"
          >
            {{ props.item.volume }}
            <template v-slot:input>
              <DecimalEditor
                v-model="props.item.volume"
                label="Объем к отгрузке"
                :outline="false"
                :height-field="32"
                :scale="3"
              />
            </template>
          </v-edit-dialog>
        </td>
        <td
          v-else
          class="text-xs-left"
        >
          {{ props.item.volume }}
        </td>
        <td
          v-if="props.item.isPartialPlan"
          class="text-xs-left"
        >
          <v-edit-dialog
            :return-value.sync="props.item.cargoPlaces"
            lazy
            large
            cancel-text="Отмена"
            save-text="Ок"
            @save="updateItem(props.item)"
          >
            <div>{{ props.item.cargoPlaces }}</div>
            <template v-slot:input>
              <DecimalEditor
                v-model="props.item.cargoPlaces"
                label="К-во мест к отгрузке"
                :outline="false"
                :height-field="32"
              />
            </template>
          </v-edit-dialog>
        </td>
        <td
          v-else
          class="text-xs-left"
        >
          {{ props.item.cargoPlaces }}
        </td>
        <td class="text-xs-left">
          <v-switch
            v-model="props.item.isPartialPlan"
            :label="
              props.item.isPartialPlan
                ? 'Частичная выдача товара'
                : 'Полная выдача товара'
            "
            color="red lighten-1"
            hide-details
            class="switch-color"
            :disabled="checkPartialPlanDisabled(props.item)"
            @change="updateItem(props.item)"
          />
        </td>
        <td class="text-xs-left">
          {{ props.item.releasedVolume }}
        </td>
        <td class="text-xs-left">
          {{ props.item.releasedCargoSizes }}
        </td>
        <td class="text-xs-left">
          {{ props.item.releasedCargoPlaces }}
        </td>
        <td class="text-xs-left">
          {{ props.item.releasedPackingMethod }}
        </td>
        <td class="text-xs-left">
          <v-chip
            v-if="typeof props.item.isPartialFact === 'boolean'"
            slot="activator"
            text-color="white"
            label
            :color="props.item.isPartialFact ? 'green' : 'red'"
            style="height: 25px"
            class="my-0 mx-1"
            :disabled="disabled"
          >
            {{
              props.item.isPartialFact ? "Частичная выдача" : "Полная выдача"
            }}
          </v-chip>
        </td>
        <td>
          <ArrivalPlaceNumberSelect :item="props.item" />
        </td>
        <td class="text-xs-left">
          <v-chip
            slot="activator"
            text-color="white"
            label
            :color="props.item.released ? 'green' : 'red'"
            style="height: 25px"
            class="my-0 mx-1"
            :disabled="disabled"
          >
            {{ props.item.released ? "Да" : "Нет" }}
          </v-chip>
        </td>
        <td class="text-xs-left">
          <v-edit-dialog
            :return-value.sync="props.item.notes"
            lazy
            large
            cancel-text="Отмена"
            save-text="Ок"
            @save="updateItem(props.item)"
          >
            <div>{{ props.item.notes }}</div>
            <template v-slot:input>
              <v-text-field
                v-model="props.item.notes"
                label="Комментарии"
                hide-details
                data-test="notes"
                :disabled="disabled"
              />
            </template>
          </v-edit-dialog>
        </td>
        <td v-if="!disabled">
          <MenuRowActions
            :list="rowActions"
            :value="props.item"
            :index="shippings.indexOf(props.item)"
            :last-index="shippings.length - 1"
            :open-on-click="true"
            @removeItem="removeItem"
            @moveUp="moveUp"
            @moveDown="moveDown"
          />
        </td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import arrayMove from "array-move";
import * as ordersApi from "../../../backend/releaseOrdersApi.js";
import * as basErpApi from "../../../backend/basErpApi.js";
import ArrivalPlaceNumberSelect from "../components/arrival-place/ArrivalPlaceNumberSelect.vue";
export default {
  components: {
    ArrivalPlaceNumberSelect,
  },
  props: ["id", "disabled"],
  data() {
    return {
      headers: [
        {
          text: "Номер поставки",
          sortable: false,
          align: "left",
          value: "shippingNumber",
        },
        {
          text: "Маршрут",
          sortable: false,
          align: "left",
          value: "routeNumber",
        },
        { text: "Клиент", sortable: false, align: "left", value: "client" },
        { text: "Продавец", sortable: false, align: "left", value: "sender" },
        {
          text: "Номер проформы",
          sortable: false,
          align: "left",
          value: "number",
        },
        {
          text: "Объем к отгрузке",
          sortable: false,
          align: "left",
          value: "volume",
        },
        {
          text: "Кол-во мест к отгрузке",
          sortable: false,
          align: "left",
          value: "cargoPlaces",
        },
        {
          text: "Выдача товара План",
          sortable: false,
          align: "left",
          value: "isPartialPlan",
        },
        {
          text: "Отгруженный объем",
          sortable: false,
          align: "left",
          value: "releasedVolume",
        },
        {
          text: "Отгруженные размеры упаковок",
          sortable: false,
          align: "left",
          value: "releasedCargoSizes",
        },
        {
          text: "Отгруженное кол-во грузовых мест",
          sortable: false,
          align: "left",
          value: "releasedCargoPlaces",
        },
        {
          text: "Отгруженные типы упаковок",
          sortable: false,
          align: "left",
          value: "releasedPackingMethod",
        },
        {
          text: "Выдача товара Факт",
          sortable: false,
          align: "left",
          value: "IsPartialFact",
        },
        {
          text: "Адрес места прибытия",
          sortable: false,
          align: "left",
          value: "",
        },
        {
          text: "Отгружено",
          sortable: false,
          align: "left",
          value: "released",
        },
        { text: "Комментарий", sortable: false, align: "left", value: "notes" },
        { text: "", sortable: false, align: "left" },
      ],
      loading: false,
      needSync: false,
    };
  },
  computed: {
    shippings: {
      get() {
        if (+this.id) {
          return this.$store.getters["releaseOrders/shippings"];
        }
        return [];
      },
      set(value) {
        this.$store.commit("releaseOrders/setShippings", value);
      },
    },
    rowActions() {
      if (this.shippings.length > 1) {
        return [
          {
            title: "Вверх",
            name: "moveUp",
            action: this.moveUp,
            type: "icon",
            icon: "arrow_upward",
            disabled: false,
          },
          {
            title: "Вниз",
            name: "moveDown",
            action: this.moveDown,
            type: "icon",
            icon: "arrow_downward",
            disabled: false,
          },
          {
            title: "Удалить",
            name: "removeItem",
            action: this.removeItem,
            type: "icon",
            icon: "delete",
            disabled: false,
          },
        ];
      } else {
        return [
          {
            title: "Удалить",
            name: "removeItem",
            action: this.removeItem,
            type: "icon",
            icon: "delete",
            disabled: false,
          },
        ];
      }
    },
  },
  async created() {
    if (+this.id) {
      await this.getShippingsItems();
    }
  },
  methods: {
    async getShippingsItems() {
      this.loading = true;
      await this.$store.dispatch("releaseOrders/getShippings", this.id);
      this.loading = false;
    },
    async updateItem(itemUpdate) {
      if (this.disabled) {
        return;
      }
      this.loading = true;
      try {
        const newItem = {
          shippingId: itemUpdate.shippingId,
          volume: +itemUpdate.volume,
          cargoPlaces: +itemUpdate.cargoPlaces,
          number: itemUpdate.number,
          notes: itemUpdate.notes,
          arrivalPlaceId: itemUpdate.arrivalPlaceId || null,
          isPartialPlan: itemUpdate.isPartialPlan,
        };
        await ordersApi.updateReleaseOrdersShipping(
          this.id,
          itemUpdate.id,
          newItem,
        );
        this.needSync = await basErpApi.getNeedSync(this.id);
        this.$store.commit("releaseOrders/setNeedSync", this.needSync);
        this.loading = false;
      } catch (error) {
        await this.getShippingsItems();
        this.loading = false;
        throw error;
      }
    },
    async removeItem(item) {
      this.loading = true;
      await ordersApi.deleteReleaseOrdersShipping(this.id, item.id);
      await this.getShippingsItems();
      this.needSync = await basErpApi.getNeedSync(this.id);
      this.$store.commit("releaseOrders/setNeedSync", this.needSync);
      this.loading = false;
    },
    async moveUp(item) {
      const from = this.shippings.indexOf(item);
      const to = from === 0 ? 0 : from - 1;
      this.shippings = arrayMove(this.shippings, from, to);
      this.loading = true;
      await ordersApi.saveReleaseOrdersShippingsPosition(this.id, item.id, to);
      this.needSync = await basErpApi.getNeedSync(this.id);
      this.$store.commit("releaseOrders/setNeedSync", this.needSync);
      this.loading = false;
    },
    async moveDown(item) {
      const from = this.shippings.indexOf(item);
      const to = from === this.shippings.length - 1 ? from : from + 1;
      this.shippings = arrayMove(this.shippings, from, to);
      this.loading = true;
      await ordersApi.saveReleaseOrdersShippingsPosition(this.id, item.id, to);
      this.needSync = await basErpApi.getNeedSync(this.id);
      this.$store.commit("releaseOrders/setNeedSync", this.needSync);
      this.loading = false;
    },
    resetLoaders() {
      this.loading = false;
    },
    checkPartialPlanDisabled(item) {
      return this.disabled || item.isShipped;
    },
  },
};
</script>
<style>
.switch-color .v-input__control .v-input--selection-controls__input {
  color: #66bb6a;
}
.switch-color .v-input__control .theme--light.v-input--switch__track {
  color: #66bb6a;
}
.switch-color .v-input__control .theme--light.v-input--switch__thumb {
  color: #66bb6a;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style
>>
